import { handleActions } from 'redux-actions'

import {
  PUT_EXTRAS,
} from './extras.actions'
import { LOGOUT } from '../../actions'

const initialState = {
  data: {},
}

export default handleActions({
  [PUT_EXTRAS]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      ...action.payload,
    },
  }),
  [LOGOUT]: () => initialState,
}, initialState)
